import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesHomepageWeb } from './HomepageWeb.proptypes';

import { EventBanner } from '../../shared/components/EventBanner';
import { Layout } from '../../shared/components/Layout';
import { Seo } from '../../shared/components/SEO';
import { SliceZoneHomepageWeb } from './components/SliceZoneHomepageWeb';

const HomepageWeb = ({ data }) => {
  if (!data) {
    return null;
  }

  const {
    prismicHomepageWeb: document,
    prismicFooter,
    prismicLocalization,
    prismicNavigation,
  } = data || '';

  const {
    alternate_languages: alternateLanguages,
    lang,
    type,
    url,
    data: {
      body: slices,
      banner_join_event_button_label: bannerJoinEventButtonLabel,
      banner_join_event_label: bannerJoinEventLabel,
      banner_join_event_datatrack: bannerJoinEventDatatrack,
      banner_join_event_placeholder: bannerJoinEventPlaceholder,
      banner_join_event_illustration: bannerJoinEventIllustration,
    } = {},
  } = document || '';

  const bannerJoinEvent = {
    bannerJoinEventDatatrack,
    bannerJoinEventButtonLabel,
    bannerJoinEventLabel,
    bannerJoinEventPlaceholder,
    bannerJoinEventIllustration,
  };

  const activeDoc = {
    lang,
    type,
    url,
    alternateLanguages,
  };

  return (
    <Layout
      activeDocMeta={activeDoc}
      footer={prismicFooter}
      localization={prismicLocalization}
      navigation={prismicNavigation}
    >
      <EventBanner content={bannerJoinEvent} />
      <SliceZoneHomepageWeb slices={slices} />
    </Layout>
  );
};

export const Head = ({ data }) => {
  const { prismicHomepageWeb: document, site: prismicSite } = data || '';

  const {
    data: { meta_title: metaTitle, faq_content: FAQContent, reviews } = {},
  } = document || '';

  const seoTitle = `${metaTitle || ''}`;

  const hasFAQ =
    FAQContent.length >= 1
      ? FAQContent[0].answer !== null && FAQContent[0].question !== null
      : false;

  return (
    <Seo
      defaultDocument={document}
      document={document}
      FAQContent={FAQContent}
      hasFAQ={hasFAQ}
      isArticle={false}
      reviews={reviews}
      site={prismicSite}
      title={seoTitle}
    />
  );
};

HomepageWeb.propTypes = {
  /**
   * GraphQL query result.
   */
  data: PropTypes.shape(propTypesHomepageWeb),
};

export const query = graphql`
  query homepagewebQuery($lang: String) {
    prismicHomepageWeb(lang: { eq: $lang }) {
      ...DataHomepageWeb
    }
    prismicNavigation(lang: { eq: $lang }) {
      ...DataNavigation
    }
    prismicFooter(lang: { eq: $lang }) {
      ...DataFooter
    }
    prismicLocalization(lang: { eq: $lang }) {
      ...DataLocalization
    }
    site {
      buildTime(formatString: "YYYY-MM-DD")
    }
  }
`;

export default HomepageWeb;
